import abstractModel from '../../../core/MercatelyModel';
import { MERCATELY_API_V2 } from '../../../constants/AppConstants';
import { msInboxApiUrl } from '../../../services/inbox/msInboxClient';
import { isInboxMsChat } from '../../../services/inbox/inboxMsChatPlatform';

// CSRF Token
const csrfToken = document.querySelector('[name=csrf-token]').content;

// Resources
const resource = `${MERCATELY_API_V2}/chat_actions/quick_answers`;

// Model
const model = abstractModel(resource);

function formDataToJson(formData) {
  const json = {};
  for (const [key, value] of formData.entries()) {
    json[key] = value;
  }
  return json;
}

model.sendMessage = async (body) => {
  let platform = '';

  if (body instanceof FormData) {
    platform = body.get('platform');
    if (isInboxMsChat(platform)) {
      const json = formDataToJson(body);
      return model.post(json, { path: msInboxApiUrl('/chat_actions/quick_answers') });
    }
  } else if (body && typeof body === 'object') {
    platform = body.platform;
    if (isInboxMsChat(platform)) {
      return model.post(body, { path: msInboxApiUrl('/chat_actions/quick_answers') });
    }
  }

  return model.post(body, { csrfToken });
};

export default model;
